import { useState } from "react";
import styled from "styled-components";

import SignupItem from "./SignupItem";
import {
  SectionTabBar,
  SectionTabButton,
  SectionTabBarWrapper,
} from "../SectionTabBar";

export default function Giving() {
  const [selectedItem, setSelectedItem] = useState(false);
  return (
    <Wrapper>
      <SectionTabBarWrapper>
        <SectionTabBar buttonsPerRow={2}>
          <SectionTabButton
            icon="fa-solid fa-circle-plus"
            title="Make a New Signup"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
        </SectionTabBar>
      </SectionTabBarWrapper>
      <SignupsList>
        <SignupItem
          icon="fa-solid fa-ticket"
          title="Fall Festival Tickets"
          count={24}
          max={50}
        />
        <SignupItem
          icon="fa-solid fa-check-square"
          title="Upcoming Series Poll"
          count={24}
        />
        <SignupItem icon="fa-solid fa-list-check" title="Signup" count={24} />
        <SignupItem
          icon="fa-solid fa-users"
          title="Volunteers"
          count={24}
          max={50}
        />
        <SignupItem
          icon="fa-solid fa-calendar-alt"
          title="Sunday Potluck"
          count={24}
          max={50}
        />
      </SignupsList>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-bottom: 12px;
  position: relative;
`;
const SignupsList = styled.div`
  margin: 0 6px;
`;
